var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDresser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 3c-1.1 0-2 .9-2 2v3h20V5a2 2 0 0 0-2-2zm6 2h4v1h-4zM2 9v5h20V9zm8 2h4v1h-4zm-8 4v3a2 2 0 0 0 2 2v1h2v-1h12v1h2v-1c1.11 0 2-.89 2-2v-3zm8 2h4v1h-4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDresser);
export default __webpack_public_path__ + "static/media/dresser.ac563d30a9f7500d56c55f6868684458.svg";
export { ForwardRef as ReactComponent };